<template>
  <main>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("heading.daily-programs") }}</v-toolbar-title>
      <v-spacer />
      <v-btn :to="{ name: 'create-daily-program' }" large class="primary">
        <v-icon left>mdi-plus</v-icon>
        {{ $t("button.create") }}
      </v-btn>
    </v-toolbar>

    <!-- table -->
    <wrapping-table
      ref="table_ref"
      :headersName="headers"
      :pathName="`packages/${$route.params.slug}/daily-programs`"
      resName="daily_programs"
      class="table-row"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center">{{ item.name }}</td>
        <td class="text-sm-center">{{ item.number }}</td>

        <td class="text-sm-center">
          <v-btn
            icon
            color="info"
            :to="{
              name: 'edit-daily-program',
              params: { program_id: item.id, slug: $route.params.slug }
            }"
          >
            <v-icon :title="$t('icon.edit')" small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon
              color="error"
              @click="handleDelete(item, index)"
              :title="$t('icon.delete')"
              small
              >mdi-delete</v-icon
            >
          </v-btn>
        </td>
      </template>
    </wrapping-table>
    <!-- table -->
  </main>
</template>

<script>
export default {
  name: "DailyPrograms",
  data() {
    return {
      headers: ["name", "number", "actions"]
    };
  },
  methods: {
    handleDelete({ id }, index) {
      this.$refs.table_ref.handleDelete(id, index);
    }
  }
};
</script>
